<template>
  <section class="app-transporte">
    <v-container grid-list-xl style="max-width: 600px">
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <section class="d-flex justify-center">
            <img width="130" src="@/assets/vai-vem/vaivem-icon.svg" />
          </section>

          <v-card outlined class="app-card">
            <v-card-title class="app-card-title justify-space-between">
              VaiVem
              <v-btn @click="logout()" depressed>
                Sair
                <v-icon right>fa-arrow-right</v-icon>
              </v-btn>
            </v-card-title>

            <v-form ref="form" lazy-validation @submit.prevent="confirmation">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.cpf"
                    placeholder="Digite o CPF"
                    v-mask="'###.###.###-##'"
                    label="CPF*"
                    :rules="[rules.required, rules.cpf]"
                    filled
                    rounded
                    dense
                    class="ma-3"
                  />
                </v-col>
              </v-row>
            </v-form>

            <div class="loading" v-if="isLoading">
              <v-progress-circular
                :size="25"
                color="primary"
                indeterminate
              />
            </div>

            <v-col cols="12" class="d-flex justify-center">
              <v-input
                :value="form.recaptcha"
                :rules="[rules.required]"
                :error-messages="
                  !form.recaptcha && $refs.form?.lazyValidation
                    ? ['Esse campo deve ser preenchido']
                    : []
                "
                hide-details="auto"
                class="recaptcha-input"
              >
                <template #default>
                  <div class="recaptcha-wrapper">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                    />
                  </div>
                </template>
              </v-input>
            </v-col>

            <div class="d-flex justify-center mb-2">
              <v-btn
                @click="confirmation()"
                text-color="white"
                color="green"
                depressed
                dark
              >
                Confirmar Entrega
                <v-icon right dark>fa-check-circle</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="modalMensagem" max-width="420">
      <v-card class="pa-4">

        <div class="modal-header" :class="mensagemTipo === 'success' ? 'success' : 'error'">
          <v-icon large color="white">
            {{ mensagemTipo === 'success' ? 'check_circle' : 'error' }}
          </v-icon>
        </div>

        <h3 class="modal-title">{{ mensagemTitulo }}</h3>

        <p class="modal-text">
          {{ mensagemTexto }}
        </p>

        <v-btn
          color="primary"
          block
          class="mt-4"
          @click="modalMensagem = false"
        >
          Fechar
        </v-btn>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";
import VaiVemAuthService from "@/services/vai-vem.auth.service";
import VaiVemService from "@/services/vai-vem.service";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { router } from "@/router";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import { validateCpf } from "@/helpers/cpf.validator";
import GlobalStore from "@/store/modules/global";

dayjs.extend(customParseFormat).locale("pt-BR");

export default {
  metaInfo: { title: "VaiVem" },

  components: { VueRecaptcha },
  directives: { mask },

  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,

    form: {
      cpf: null,
      recaptcha: null,
    },

    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      cpf: (value) => !!validateCpf(value) || "CPF inválido",
    },

    modalMensagem: false,
    mensagemTitulo: "",
    mensagemTexto: "",
    mensagemTipo: "",

    dateNow: Date.now(),
  }),

  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },

    expiredRecaptcha() {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
      this.form.recaptcha = null;
    },

    confirmation() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;

      if (!GlobalStore.user) {
        this.logout();
        this.abrirModalErro("Sessão expirada", "Sua sessão expirou, faça login novamente.");
        return;
      }

      const { id, name } = GlobalStore.user;
      this.isLoading = true;

      const { cpf } = this.form;

      VaiVemService.confirmReceipt(
        FunctionsCommuns.removeFormat(cpf),
        id,
        name
      ).subscribe(
        () => {
          this.isLoading = false;
          this.expiredRecaptcha();
          this.abrirModalSucesso("Sucesso", "Entrega realizada com sucesso!");
        },

        (err) => {
          this.isLoading = false;
          this.expiredRecaptcha();

          const apiMsg =
            err?.response?.data ||
            err?.response?.message ||
            "Erro desconhecido ao confirmar entrega.";

          this.abrirModalErro("Atenção", apiMsg);

          this.verifyToken();
        }
      );
    },

    abrirModalErro(titulo, texto) {
      this.mensagemTitulo = titulo;
      this.mensagemTexto = texto;
      this.mensagemTipo = "error";
      this.modalMensagem = true;
    },

    abrirModalSucesso(titulo, texto) {
      this.mensagemTitulo = titulo;
      this.mensagemTexto = texto;
      this.mensagemTipo = "success";
      this.modalMensagem = true;
    },

    logout() {
      VaiVemAuthService.logout(null, null, true);
    },

    verifyToken() {
      const expireToken = VaiVemAuthService.expireToken();
      if (this.dateNow > expireToken) {
        VaiVemAuthService.logout(
          "warning",
          "Sua sessão expirou, faça login novamente."
        );
        router.push({ name: "estudante-confirma" });
      }
    },
  },

  mounted() {
    VaiVemAuthService.loadUserFromLocalStorage();
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;

  .v-progress-circular {
    margin: auto;
  }
}

.modal-header {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin: 0 auto 15px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-header.success {
  background: #4caf50 !important;
}
.modal-header.error {
  background: #e53935 !important;
}
.modal-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}
.modal-text {
  text-align: center;
  font-size: 14px;
  color: #444;
}

.recaptcha-input {
  display: inline-block !important;
  width: auto !important;
  max-width: 340px;
}

.recaptcha-wrapper {
  display: inline-block;
  text-align: center;
}
</style>
